import { IRestoreQuestion } from '@/contracts/modules/education/use-case/IRestoreQuestion'
import { RestoreQuestionRoute } from '@/modules/education/v1/api/v1/questions/RestoreQuestion/RestoreQuestionRoute'

export class RestoreQuestion implements IRestoreQuestion {
  async exec(question: string): Promise<string> {
    const response = await new RestoreQuestionRoute(question).exec(null)
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData().uuid
  }
}
